import { ListenSVG, Icon } from "@newsela/angelou";
import useGetUserExperimentSegment from "@/features/useGetUserExperimentSegment";
import useAppcues from "@/utils/useAppcues";
import focusElementRefKeys from "@/view/constants/focusElementRefKeys";
import useReadAloudMode from "@/view/ReadAloudControls/useReadAloudMode";
import useFocusManager from "@/view/utils/useFocusManager";
import { ReadAloudContentModes } from "@/view/ReadAloudControls/useReadAloudMode/constants";

import ContentLevel from "@/types/models/ContentLevel.interface";
import SecondaryActionButton from "../../SecondaryActionsToolbar/SecondaryActionButton";
interface IReadActionProps {
  activeSubMenu: string | null | undefined;
  currentLevel: ContentLevel | undefined;
  disabled: boolean;
  hoverLabel: string;
  isMobile: boolean | undefined;
  readAloudButtonRef: object | undefined;
}

const ReadAction = ({
  activeSubMenu,
  currentLevel,
  disabled,
  hoverLabel,
  isMobile,
  readAloudButtonRef,
}: IReadActionProps) => {
  const appcues = useAppcues();

  const { focusElement } = useFocusManager();

  const action = {
    label: "Listen",
    name: "Read",
  };

  const {
    isReadAloudModeActive,
    setIsReadAloudModeActive,
    setReadAloudContentMode,
  } = useReadAloudMode();

  const [readAloudQuizzesVariation] =
    useGetUserExperimentSegment("read_aloud_quizzes");
  const canReadAloudQuizzes = readAloudQuizzesVariation === "on";

  if (isMobile && !!activeSubMenu) return null;

  const eventProperties = {
    objectType: "Content",
    actionName: action.name,
    actionPrefix: "Initiate",
    streamProperties: {
      content_type: "Article",
      description: "Read Content",
      content_id: currentLevel?.id,
    },
  };

  const ariaProps = {
    "aria-expanded": isReadAloudModeActive,
  };

  const sendAppCuesEvent = () => {
    if (!isReadAloudModeActive && canReadAloudQuizzes) {
      const APP_CUES_EVENT =
        "User with Quiz Read Aloud feature started Read Aloud mode for Article";

      return appcues?.track(APP_CUES_EVENT);
    }
  };

  const onClick = () => {
    sendAppCuesEvent();
    focusElement(focusElementRefKeys.readAloudPlayPauseButton);
    setIsReadAloudModeActive(!isReadAloudModeActive);
    setReadAloudContentMode(ReadAloudContentModes.ARTICLE);
  };

  return (
    <SecondaryActionButton
      ariaProps={ariaProps}
      buttonRef={readAloudButtonRef}
      disabled={disabled}
      eventProperties={eventProperties}
      title={hoverLabel}
      hoverLabel={hoverLabel}
      icon={<Icon SvgComponent={ListenSVG} />}
      isActive={isReadAloudModeActive}
      onClick={onClick}
      dataProps={{
        "data-qa-selector": isReadAloudModeActive
          ? "turn-off-listen-mode"
          : "turn-on-listen-mode",
      }}
    />
  );
};

export default ReadAction;
